module.exports = new __parcel__URL__("29838_sq.07fdc4f2.jpg").toString();